const { ClickGroup } = window.mwf;

/**
 * Grabs all click groups currently on the page and overrides their click handler
 */
const updateClickGroups = () => {
	if ( 'undefined' === typeof ClickGroup ) {
		return;
	}

	const clickGroups = ClickGroup.getInstances();

	if ( !clickGroups.length ) {
		return;
	}

	for ( const clickGroup of clickGroups ) {
		clickGroup.update( {
			onClick: () => clickGroup.target.click()
		} );
	}
};


/**
 * Initializes ClickGroup on new content loaded via AJAX
 */
const initNewClickGroups = () => {
	const allClickGroupElements = document.querySelectorAll( '[data-mount="click-group"]' );

	if ( allClickGroupElements.length ) {
		for ( const clickGroupElement of allClickGroupElements ) {
			new ClickGroup( {
				el: clickGroupElement,
			} );
		}
		updateClickGroups();
	}
};


/**
 * Overrides MWF default click group behavior to work properly with analytics by
 * forcing an actual clink on the click group's target.
 */
const init = () => {
	updateClickGroups();
	document.addEventListener( 'msr:facetedSearchUpdate', initNewClickGroups );
	document.addEventListener( 'msr:loadTabComplete', initNewClickGroups );
};

export default init;
